/** In-page id for the worlds carousel; used in hash and scroll targets. */
export const WORLDS_SECTION_ID = 'worlds';

export function getWorldsHref() {
  return `/#${WORLDS_SECTION_ID}`;
}

export function getWorldsHash() {
  return `#${WORLDS_SECTION_ID}`;
}
